import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

const styles = {
  primary: {
    color: '#fff',
    bgcolor: 'var(--primary-color)',
    '&:hover': {
      bgcolor: 'var(--primary-color-darken)',
      color: '#fff',
    },
  },
  secondary: {
    color: 'var(--font-color-primary)',
    bgcolor: '#efefef',
    '&:hover': {
      bgcolor: '#e6e6e6',
      color: 'var(--font-color-primary)',
    },
  },
  rounded: {
    borderRadius: '24px',
    color: '#fff',
    bgcolor: 'var(--primary-color)',
    '&:hover': {
      bgcolor: 'var(--primary-color-darken)',
      color: '#fff',
    },
  },
  text: {
    borderRadius: '24px',
    bgcolor: 'transparent',
    color: 'var(--font-color-primary)',
    '&:hover': {
      bgcolor: 'transparent',
      color: 'var(--font-color-primary)',
    },
  },
};

function FormButton({ variant = 'primary', children, ...other }) {
  return (
    <Button
      sx={{
        height: 34,
        width: 'auto',
        fontSize: 14,
        pr: '16px',
        pl: '16px',
        borderRadius: '12px',
        textTransform: 'none',
        ...styles[variant],
      }}
      {...other}
    >
      {children}
    </Button>
  );
}

FormButton.propTypes = {
  variant: PropTypes.string.isRequired,
};

export default FormButton;
